// Central image resolver for HESHAURA. Catalogue images live in object storage
// (key = storage path) and are served through the backend file route.

export const getProductImage = (key, fallbackAlt = "HESHAURA handcrafted bracelet") => {
  if (typeof key === "string" && key.length > 0) {
    const encoded = key.split("/").map(encodeURIComponent).join("/");
    return { src: `${process.env.REACT_APP_BACKEND_URL}/api/files/${encoded}`, alt: fallbackAlt };
  }
  return { src: null, alt: fallbackAlt };
};
